import React from 'react'
import { Candidate } from '../../../candidate/candidate'
import { useBoardContext } from '../../../hooks/use-board'
import { useNavigate } from '@tanstack/react-router'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { CandidateCard } from '../../../candidate/components/candidate-card'
import { DragData } from './board'

export const MemoizedSortableCard = React.memo(
    function SortableCard({
        item,
        columnId,
        index,
        collapsed = true,
    }: {
        item: Candidate
        columnId: string
        index: number
        collapsed?: boolean
    }) {
        const { setSelected, selected, showPhone } = useBoardContext()
        const navigate = useNavigate()
        const { attributes, listeners, setNodeRef, transform, isDragging } = useSortable({
            id: item.id,
            data: {
                item,
                fromColumn: columnId,
                index,
            } as DragData,
        })

        const style = {
            transform: CSS.Transform.toString(transform),
            cursor: 'grab',
            opacity: isDragging ? 0.5 : 1,
        }

        return (
            <div
                ref={setNodeRef}
                style={style}
                {...attributes}
                {...listeners}
            >
                <CandidateCard
                    onSelected={() =>
                        setSelected((prev) => {
                            return {
                                ...prev,
                                [item.id]: true,
                            }
                        })
                    }
                    onDeselected={() =>
                        setSelected((prev) => {
                            const next = { ...prev }

                            delete next[item.id]

                            return next
                        })
                    }
                    onClick={() => {
                        navigate({
                            to: '.',
                            search: (search) => ({
                                ...search,
                                candidateId: item.id,
                            }),
                        })
                    }}
                    candidate={item}
                    collapsed={collapsed}
                    showPhone={showPhone}
                    selected={selected[item.id]}
                />
            </div>
        )
    },
    function (prevProps, nextProps) {
        return (
            prevProps.item === nextProps.item &&
            prevProps.columnId === nextProps.columnId &&
            prevProps.index === nextProps.index &&
            prevProps.collapsed === nextProps.collapsed
        )
    }
)
